var servername = 'https://api.ourstorysong.com'
if (window.location.hostname === 'localhost') {
  servername = 'http://localhost:5000'
}

export const server = servername
